import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    Stack,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Link,
    InputLeftElement,
  } from '@chakra-ui/react';
  import { FormEvent, useCallback, useEffect, useState } from 'react';
  import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
  import {isLoggedIn, signUp} from "../fetch/auth";
import { ApiError } from '../fetch';
import { ROUTES } from '../routes';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from './user-context';
import { ERRORS } from '../errors';

  export const SignupCard=()=> {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState('');
    const { refreshCurrentUser } = useCurrentUser();

     
      const signup = useCallback(
        async (e: FormEvent | MouseEvent) => {
          e.preventDefault();
          if (!isValidPassword(password)){               
            setError(ERRORS.INVALID_PASSWORD);
            return;
          }
          try {
            await signUp(email,name,address,password,phone);
            refreshCurrentUser();          
            navigate(ROUTES.HOME);
          } catch (e) {
            setError((e as ApiError).message);
          }
        },
        [email,name,address,password,phone, refreshCurrentUser, navigate]
      );
    
      useEffect(() => {
        if (isLoggedIn()) {
          navigate(ROUTES.HOME);
        }
      }, [navigate]);

      const isValidPassword=(pass: string): boolean=>{
        return(/[A-Z]/.test(pass) &&
               /[a-z]/.test(pass) &&
               /[0-9]/.test(pass) &&
               pass.length>=6 &&
               pass.length<=32);
      }
    return (
      <form onSubmit={signup} dir='rtl'>
      <Flex
        minH={'100vh'}
    
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')} direction={'column'}>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              تسجيل مستخدم جديد
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
               لتستمتع بخدمات برو إكسبريس✌️
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              
                  <FormControl id="firstName" isRequired>
                    <FormLabel>الاسم</FormLabel>
                    <Input type="text" value={name} onChange={e => setName(e.target.value)}/>
                  </FormControl>
               
            
              
              <FormControl id="email" isRequired>
                <FormLabel>البريد الإلكتروني</FormLabel>
                <Input type="email" value={email} onChange={e => setEmail(e.target.value)}/>
              </FormControl>

              <FormControl id="phone" isRequired>
                <FormLabel>التليفون المحمول</FormLabel>
                <Input type="number" value={phone} onChange={e => setPhone(e.target.value)}/>
              </FormControl>

              <FormControl id="address">
                <FormLabel>العنوان</FormLabel>
                <Input type="text" value={address} onChange={e => setAddress(e.target.value)}/>
              </FormControl>

              <FormControl id="password" isRequired>
                <FormLabel>كلمة المرور</FormLabel>
                <InputGroup>
                  <Input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} />
                  <InputLeftElement h={'full'}>
                    <Button
                      variant={'ghost'}
                      onClick={() =>
                        setShowPassword((showPassword) => !showPassword)
                      }>
                      {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                    </Button>
                  </InputLeftElement>
                </InputGroup>
                <Text marginTop={2} color={'red.500'} fontSize={'sm'}>{ERRORS.INVALID_PASSWORD}</Text>
              </FormControl>
              <Stack spacing={10} pt={2}>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="lg"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }}>
                  تسجيل
                </Button>
              </Stack>
              {!!error && <Text color="red.700">{error}</Text>}
              <Stack pt={6}>
                <Text align={'center'}>
                 مستخدم بالفعل؟ <Link href={ROUTES.SIGN_IN} color={'blue.400'}>تسجيل دخول</Link>
                </Text>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      
      </Flex>
      </form>
    );
  }